export const OPERATOR_QUERY_PARAM_KEY = 'filter_operator_ids';
export const TRANSITIONS_COUNT_QUERY_PARAM_KEY = 'filter_direct_flight';
export const PAYMENT_BENEFITS_QUERY_PARAM_KEY = 'filter_payment_benefits';
export const CONFIRMABILITY_PARAM_KEY = 'filter_confirmability';
